import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

import { Box, Button, CircularProgress, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import { Tooltip } from "@mui/material";

import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useState, useEffect } from "react";

import { IoArrowBack } from "react-icons/io5";

import { LedgerReport } from '../reports/companyLedgersReport/Report';
import TablePaginationActions from '../../../base-components/TablePaginationActions';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CustomModal from '../../../base-components/CustomModal';
import dayjs from 'dayjs';
import { isDynamicStaffRole } from '../../../utils/roleAccess';
import { PageHeader } from "../../../ui";



const BASE_URL = process.env.REACT_APP_BASE_URL;
function CompanyLedgers() {

  const navigate = useNavigate()
  // const [searchParams] = useSearchParams();
  // const voucher_id = searchParams.get("voucher_id");
  // const subscription_id = searchParams.get("subscription_id");
  // const company_id = searchParams.get("company_id");
  //states for this page
  const [loading, setLoading] = useState(false)
  const [transactions, setTransactions] = useState([])
  //roles and permission states
  const [role, setRole] = useState('')
  const [location_id, setLocationID] = useState('')
  const [company_id, setCompanyID] = useState('')
  const [member_id, setMemberID] = useState('')
  //pagintion states
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0)
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [transactionType, setSubscriptionType] = useState("");
  const [filtered_transaction, setFilteredTransaction] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [summary, setSummary] = useState({});
  const [memberSummary, setMemberSummary] = useState({});
  const [filter, setFilter] = useState('');
  const [isViewModalOpen, setIsViewModalOpen] = useState(false)
  const [transactionFilter, setTransactionFilter] = useState('all'); // 'all', 'cash', 'bank'
  const tabData = [
    { key: 'all', label: 'All' },
    { key: 'cash', label: 'Cash' },
    { key: 'bank transfer', label: 'Bank Transfer' },
  ];
  const [tabType, setTabType] = useState('all')
  const [reportType, setReportType] = useState('ledgers'); // 'ledgers' or 'bankReports'
  const [hasBankIntegration, setHasBankIntegration] = useState(false);
  const [startFromZero, setStartFromZero] = useState(false);
  const [paymentStatusFilter, setPaymentStatusFilter] = useState('all'); // 'all' | 'paid' | 'unpaid'
  const [bankNameFilter, setBankNameFilter] = useState('all'); // 'all' | bank name

  const applyLedgerFilters = (rows, accountTab, paymentStatus) => {
    let filtered = Array.isArray(rows) ? rows : [];
    if (accountTab && accountTab !== 'all') {
      filtered = filtered.filter(
        (tx) => (tx.account || '').toLowerCase() === accountTab.toLowerCase()
      );
    }
    if (paymentStatus === 'paid') {
      filtered = filtered.filter((tx) => tx.is_voucher_paid === true);
    } else if (paymentStatus === 'unpaid') {
      filtered = filtered.filter((tx) => tx.is_voucher_paid === false);
    }
    return filtered;
  };

  const bankNames = Array.isArray(transactions)
    ? [...new Set(
      transactions
        .map((tx) => tx.bank_name)
        .filter((name) => name && name !== '---')
    )].sort()
    : [];

  const applyBankNameFilter = (rows, selectedBank) => {
    let filtered = Array.isArray(rows) ? [...rows] : [];
    if (selectedBank && selectedBank !== 'all') {
      filtered = filtered.filter((tx) => (tx.bank_name || '') === selectedBank);
      let runningBalance = 0;
      filtered = filtered.map((tx) => {
        runningBalance += Number(tx.debit) || 0;
        return { ...tx, balance: runningBalance, bankBalance: runningBalance };
      });
    }
    return filtered;
  };

  useEffect(() => {
    // Bank payment logs use payment_mode as account (ONLINE, CASH, etc.),
    // so do not apply All/Cash/Bank Transfer tab filtering here.
    if (reportType === 'bankReports') {
      setFilteredTransaction(applyBankNameFilter(transactions, bankNameFilter));
      return;
    }
    setFilteredTransaction(
      applyLedgerFilters(transactions, tabType, paymentStatusFilter)
    );
  }, [tabType, paymentStatusFilter, transactions, reportType, bankNameFilter]);

  useEffect(() => {
    const sessionStr = sessionStorage.getItem('user-info');
    if (sessionStr) {
      const session = JSON.parse(sessionStr);
      setRole(session.user.role)
      setCompanyID(session.user.company_id?._id || session.user.company_id)
      setHasBankIntegration(session.user.company?.has_bank_integration || false)
      setLocationID(session.user.location_id)
      setMemberID(session.user.member_id)
    }
    else {
      navigate('/login');
    }
  }, [])

  // useEffect(() => {
  //     setLoading(true)
  //     if(role) {
  //         getTransactions()
  //         setTimeout(()=> {
  //             setLoading(false)
  //         } , 1000)
  //     }
  // }, [role , company_id , location_id]);
  // useEffect(() => {
  //   const fetchTransactions = async () => {
  //     setLoading(true);
  //     if (role) {
  //       await getLedgerEntries(); 
  //       // await getTransactions(); 
  //       setLoading(false);       
  //     }
  //   };

  //   fetchTransactions();
  // }, [role, company_id, location_id]);



  const getLedgerEntries = async () => {
    if (!role) return;
    let endpoint = '';
    console.log(role);
    if (role === 'Admin') {
      endpoint = `getLedgerEntriesByCompanyID?company_id=${company_id}&startDate=${fromDate}&endDate=${toDate}`;
    } else if (role === 'ClubAdmin') {
      endpoint = `getLedgerEntriesByLocationID?company_id=${company_id}&location_id=${location_id}&startDate=${fromDate}&endDate=${toDate}`;
    } else if (isDynamicStaffRole(role)) {
      endpoint = `getLedgerEntriesByLocationID?company_id=${company_id}&location_id=${location_id}&startDate=${fromDate}&endDate=${toDate}`;
    }

    await fetch(BASE_URL + `ledgers/${endpoint}`)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setTabType('all'); // Reset tabType to 'all' when fetching new data
        setTransactions(data.ledgerEntries)
        setFilteredTransaction(data.ledgerEntries)
        console.log("Ledger Entries:", data.memberSummary);
        setSummary({
          companyTitle: data.companyTitle,
          openingBalance: data.openingBalance,
          closingBalance: data.closingBalance,
          totalExpenses: data.totalExpenses,
          totalReceived: data.summary.totalReceived,
          totalIncome: data.summary.totalIncome,
          totalReceivable: data.summary.totalReceivable,
          netRevenue: data.summary.netRevenue,
          totalDiscount: data.summary.totalDiscount,
          totalCashReceived: data.summary.totalCashReceived,
          totalBankReceived: data.summary.totalBankReceived,
        })
        setMemberSummary(data.memberSummary)
      })
      .catch((error) => {
        console.log(error)
      });
  }

  const getBankPaymentLogs = async () => {
    if (!role) return;
    let url = `${BASE_URL}bank-integration/successful-logs?company_id=${company_id}&startDate=${fromDate}&endDate=${toDate}`;
    if (role === 'ClubAdmin') {
      url += `&location_id=${location_id}`;
    } else if (isDynamicStaffRole(role)) {
      url += `&location_id=${location_id}`;
    }

    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        let runningBalance = 0;
        const formattedLogs = data.map(log => {
          runningBalance += log.trans_amount;
          const memberPrefix = log.location_id?.member_id_temp || '';
          const memberNum = log.member_id?.member_id || '';
          const memberFormatted = `${memberPrefix}${memberNum}`;
          const voucherID = log.voucher_id?.invoice_no || log.voucher_id?.transaction_number || (log.voucher_id?._id || log.voucher_id || log.trans_reference_number || '---');

          return {
            date: log.transaction_date,
            member_id_formatted: memberFormatted || '---',
            voucher_id_display: voucherID,
            description: `Bank Pmnt - ${log.member_id?.name || 'Walk-in'} (Voucher: ${voucherID})`,
            account: log.payment_mode || 'Bank Transfer',
            bank_name: log.bank_name || '---',
            bank_gl: log.bank_gl || log.bank_account_id?.bank_gl || '---',
            account_number: log.account_number || '---',
            payment_reference: log.trans_reference_number || log.voucher_id?.reference_number || '',
            debit: log.trans_amount,
            credit: 0,
            balance: runningBalance,
            bankBalance: runningBalance
          };
        });

        setTransactions(formattedLogs);
        setBankNameFilter('all');
        setFilteredTransaction(formattedLogs);

        setSummary({
          companyTitle: role === 'ClubAdmin' ? 'Location Bank Report' : 'Company Bank Report',
          openingBalance: 0,
          closingBalance: runningBalance,
          totalExpenses: 0,
          totalReceived: runningBalance,
          totalIncome: runningBalance,
          totalReceivable: 0,
          netRevenue: runningBalance,
          totalDiscount: 0,
          totalCashReceived: 0,
          totalBankReceived: runningBalance,
        });
        setMemberSummary({});
      })
      .catch((error) => {
        console.log(error)
      });
  }

  const getTransactions = async () => {
    if (!role) return;
    let endpoint = '';
    console.log(role);
    if (role === 'SuperAdmin') {
      endpoint = 'get-transactions';
    } else if (role === 'Admin') {
      endpoint = `get-transactions-by-company-id/${company_id}`;
    } else if (role === 'ClubAdmin') {
      endpoint = `get-transactions-by-location-id/${location_id}`;
    } else if (isDynamicStaffRole(role)) {
      endpoint = `get-transactions-by-location-id/${location_id}`;
    }
    await fetch(BASE_URL + `transaction/${endpoint}`)
      .then((response) => response.json())
      .then((data) => {
        setTransactions(data.transactions)
        setFilteredTransaction(data.transactions)
      })
      .catch((error) => {
        console.log(error)
      });
  }
  const paginatedTransactions = !filtered_transaction || filtered_transaction.length === 0 ?
    [] :
    rowsPerPage === -1
      ? filtered_transaction // Show all if "All" option is selected
      : filtered_transaction.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const bankFilteredTotal = reportType === 'bankReports' && bankNameFilter !== 'all' && Array.isArray(filtered_transaction)
    ? filtered_transaction.reduce((sum, tx) => sum + (Number(tx.debit) || 0), 0)
    : null;

  const displayClosingBalance = bankFilteredTotal !== null
    ? bankFilteredTotal
    : (summary.closingBalance !== undefined
      ? (startFromZero && summary.openingBalance ? summary.closingBalance - summary.openingBalance : summary.closingBalance)
      : 0);

  const displayNetRevenue = bankFilteredTotal !== null
    ? bankFilteredTotal
    : (summary.netRevenue ?? 0);

  const displayTotalReceived = bankFilteredTotal !== null
    ? bankFilteredTotal
    : (tabType === 'all'
      ? summary?.totalReceived
      : tabType === 'cash'
        ? summary?.totalCashReceived
        : tabType === 'bank transfer'
          ? summary?.totalBankReceived
          : 0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleNavigate = () => {
    navigate("/ledgers");

  }
  const handleBankDownload = async () => {
    const data = {
      company_id: company_id,
      location_id: role === 'ClubAdmin' ? location_id : null,
      startDate: fromDate,
      endDate: toDate
    }
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(
        BASE_URL + `bank-integration/download-logs`,
        requestOptions
      );

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'BankPaymentLogs.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Download error:", error);
    }
  }

  const handleSummaryDownload = async () => {
    if (reportType === 'bankReports') {
      return handleBankDownload();
    }
    // LedgerSummary(filtered_transaction , memberSummary , {})

    const data = {
      ledgerEntries: filtered_transaction,
      memberSummary: memberSummary,
      summary: summary,
      startDate: fromDate,
      endDate: toDate
    }
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(
        BASE_URL + `ledgers/download-ledgers-report`,
        requestOptions
      );

      // Log the full response details
      console.log("Response status:", response.status);

      if (!response.ok) {
        console.log('response is not ok');

      } else {
        console.log('response is ok');
        const blob = await response.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'GymClosingSheet.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Caught error:", error);
    }

  }

  const handleSearch = (search) => {
    setSearchQuery(search);
    let filteredtransactions = [];
    if (search === '') {
      setFilteredTransaction(transactions);
    }
    else {
      filteredtransactions = transactions.filter((transaction) =>
        (transaction.voucher_id?.invoice_no.toLowerCase()?.includes(search.toLowerCase())) ||
        (transaction.transaction_type.toLowerCase()?.includes(search.toLowerCase())) ||
        (transaction.member_id?.member_id.toLowerCase()?.includes(search.toLowerCase())) ||
        (transaction.member_id?.name.toLowerCase()?.includes(search.toLowerCase())) ||
        transaction.amount.toString().includes(search.toString())
      );
      setFilteredTransaction(filteredtransactions);
    }
  };


  const changeDates = (value) => {
    const today = new Date();

    if (value === 'daily') {
      const formatted = today.toString("yyyy-MM-dd");
      setFromDate(formatted);
      setToDate(formatted);
    } else if (value === 'monthly') {
      const year = today.getFullYear();
      const month = today.getMonth();

      const from = dayjs(new Date(year, month, 1)).format("YYYY-MM-DD");
      const to = dayjs(new Date(year, month + 1, 0)).format("YYYY-MM-DD");

      setFromDate(from);
      setToDate(to);
    } else if (value === 'fiscalYear') {
      const year = today.getFullYear();
      const month = today.getMonth();

      let fiscalYearStart, fiscalYearEnd;

      if (month >= 6) {
        // July or later — current fiscal year
        fiscalYearStart = new Date(year, 6, 1);
        fiscalYearEnd = new Date(year + 1, 5, 30);
      } else {
        // Before July — previous fiscal year
        fiscalYearStart = new Date(year - 1, 6, 1);
        fiscalYearEnd = new Date(year, 5, 30);
      }

      const startStr = dayjs(fiscalYearStart).format("YYYY-MM-DD");
      const endStr = dayjs(fiscalYearEnd).format("YYYY-MM-DD");

      console.log('Fiscal Year Start:', startStr);
      console.log('Fiscal Year End:', endStr);

      setFromDate(startStr);
      setToDate(endStr);
    }
  };

  const handleFilter = async (type = reportType) => {
    setLoading(true);
    if (type === 'bankReports') {
      await getBankPaymentLogs();
    } else {
      await getLedgerEntries();
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const toggleViewModal = () => {
    setIsViewModalOpen(!isViewModalOpen);
  }
  const handleClear = () => {
    setLoading(true);
    setPaymentStatusFilter('all');
    setFilteredTransaction(applyLedgerFilters(transactions, tabType, 'all'));
    setFromDate("");
    setToDate("");
    setSubscriptionType("");
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  return (
    <>
      <div className="flex items-center justify-end mx-3 ">
        {/* <div   className='px-4 py-2'>
            <IoArrowBack onClick={handleNavigate}
              className="cursor-pointer text-4xl print:hidden"/>
          </div>  */}

        <div className="text-blue-800 hover:cursor-pointer hover:text-blue-900">
          <Tooltip title="Download" arrow>
            <FontAwesomeIcon
              icon={faDownload}
              fontSize="30px"
              onClick={handleSummaryDownload}
            />
          </Tooltip>
        </div>
      </div>

      <div className="m-5 print:hidden"><PageHeader title="Company Ledgers" /></div>
      {/* <div className="relative w-auto mx-5 mt-5">
        <input
          type="text"
          placeholder="Search by ID, Name or Type..."
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
          className="border border-gx-border rounded-md py-1 px-2 pl-10 outline-0 w-72"
        />
        <FontAwesomeIcon
          icon={faSearch}
          className="absolute left-3 top-2 text-gx-ink-soft"
        />
      </div> */}

      <div className="flex flex-col gap-4 p-4">
        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
          <div className="flex flex-col md:flex-row items-center gap-2 w-full md:w-auto">
            <label className="text-gx-ink font-semibold whitespace-nowrap text-sm md:text-base">Select Filter: </label>
            <Select className='w-full md:w-[200px] bg-white h-9' value={filter}
              onChange={(e) => {
                setFilter(e.target.value)
                changeDates(e.target.value)
              }
              }
            >
              <MenuItem value='daily'>Daily</MenuItem>
              <MenuItem value='monthly'>Monthly</MenuItem>
              <MenuItem value='fiscalYear'>Fiscal Year</MenuItem>
              <MenuItem value='custom'>Custom Dates</MenuItem>
            </Select>
          </div>
          <div className="flex flex-col md:flex-row items-center gap-2 w-full md:w-auto ml-2">
              <label className="text-gx-ink font-semibold whitespace-nowrap text-sm md:text-base cursor-pointer flex items-center gap-2">
                <input
                  type="checkbox"
                  className="w-4 h-4 cursor-pointer"
                  checked={startFromZero}
                  onChange={(e) => setStartFromZero(e.target.checked)}
                />
                Start From Zero
              </label>
          </div>
          {reportType === 'ledgers' && (
            <div className="flex flex-col md:flex-row items-center gap-2 w-full md:w-auto">
              <label className="text-gx-ink font-semibold whitespace-nowrap text-sm md:text-base">
                Payment Status:
              </label>
              <Select
                className="w-full md:w-[160px] bg-white h-9"
                value={paymentStatusFilter}
                onChange={(e) => setPaymentStatusFilter(e.target.value)}
                displayEmpty
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="paid">Paid</MenuItem>
                <MenuItem value="unpaid">Unpaid</MenuItem>
              </Select>
            </div>
          )}
          {reportType === 'bankReports' && (
            <div className="flex flex-col md:flex-row items-center gap-2 w-full md:w-auto">
              <label className="text-gx-ink font-semibold whitespace-nowrap text-sm md:text-base">
                Bank Name:
              </label>
              <Select
                className="w-full md:w-[200px] bg-white h-9"
                value={bankNameFilter}
                onChange={(e) => {
                  setBankNameFilter(e.target.value);
                  setPage(0);
                }}
                displayEmpty
              >
                <MenuItem value="all">All Banks</MenuItem>
                {bankNames.map((name) => (
                  <MenuItem key={name} value={name}>{name}</MenuItem>
                ))}
              </Select>
            </div>
          )}
        </div>
        {
          filter !== 'custom' && (
            <div className="flex items-center bg-gx-canvas p-1.5 rounded-full w-full md:w-auto self-start shadow-inner border border-gx-border">
              <button
                onClick={() => {
                  setReportType('ledgers');
                  setPaymentStatusFilter('all');
                  setBankNameFilter('all');
                  handleFilter('ledgers');
                }}
                className={`py-2 px-6 rounded-full font-bold text-sm transition-all duration-300 flex items-center gap-2 ${reportType === 'ledgers'
                  ? 'bg-gx-navy text-white shadow-lg transform scale-105'
                  : 'text-gx-ink-soft hover:text-gx-navy hover:bg-white'
                  }`}
              >
                Fetch Ledgers
              </button>
              {hasBankIntegration && (
                <button
                  onClick={() => {
                    setReportType('bankReports');
                    setPaymentStatusFilter('all');
                    setBankNameFilter('all');
                    handleFilter('bankReports');
                    setTabType('bank transfer');
                  }}
                  className={`py-2 px-6 rounded-full font-bold text-sm transition-all duration-300 flex items-center gap-2 ${reportType === 'bankReports'
                    ? 'bg-gx-navy text-white shadow-lg transform scale-105'
                    : 'text-gx-ink-soft hover:text-gx-navy hover:bg-white'
                    }`}
                >
                  Fetch Bank Reports
                </button>
              )}
            </div>
          )
        }
      </div>
      {
        filter === 'custom' && (
          <div className="p-4">
            <form
              onSubmit={(e) => e.preventDefault()}
              className="flex flex-col gap-4"
            >
              <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
                <div className="flex flex-col md:flex-row items-center gap-2 w-full md:w-auto">
                  <label className="text-gx-ink font-semibold">From:</label>
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    className="border border-gx-border rounded-md py-1 px-3 outline-0 text-gx-ink-soft w-full md:w-48"
                  />
                </div>

                <div className="flex flex-col md:flex-row items-center gap-2 w-full md:w-auto">
                  <label className="text-gx-ink font-semibold">To:</label>
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    disabled={!fromDate}
                    min={fromDate}
                    className="border border-gx-border rounded-md py-1 px-3 outline-0 w-full md:w-48"
                  />
                </div>

                <div className="flex items-center bg-gx-canvas p-1 rounded-md w-full md:w-auto">
                  <button
                    onClick={() => {
                      setReportType('ledgers');
                      setPaymentStatusFilter('all');
                      setBankNameFilter('all');
                      handleFilter('ledgers');
                    }}
                    className={`py-1.5 px-4 rounded-md font-semibold text-sm transition-all flex items-center gap-2 ${reportType === 'ledgers' ? 'bg-green-700 text-white shadow-md' : 'text-gx-ink-soft hover:bg-gx-border'
                      }`}
                  >
                    Fetch Ledgers
                  </button>
                  {hasBankIntegration && (
                    <button
                      onClick={() => {
                        setReportType('bankReports');
                        setPaymentStatusFilter('all');
                        setBankNameFilter('all');
                        handleFilter('bankReports');
                        setTabType('bank transfer');
                      }}
                      className={`py-1.5 px-4 rounded-md font-semibold text-sm transition-all flex items-center gap-2 ${reportType === 'bankReports' ? 'bg-green-700 text-white shadow-md' : 'text-gx-ink-soft hover:bg-gx-border'
                        }`}
                    >
                      Fetch Bank Reports
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        )
      }

      {loading ? (
        
          <div className="flex justify-center items-center mt-20 relative">
            {/* SVG Gradient Definition */}
            <svg width="0" height="0">
              <defs>
                <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#D71920" />
                  <stop offset="100%" stopColor="#F7931E" />
                </linearGradient>
              </defs>
            </svg>

            {/* Circular Progress with Gradient Stroke */}
            <CircularProgress
              thickness={4}
              size={35}
              sx={{
                "svg circle": {
                  stroke: "url(#gradientColors)", // Apply gradient stroke
                },
              }}
            />
          </div>
        
      ) : filtered_transaction && filtered_transaction.length !== 0 ? (
        <>
          {/* Summary Box */}
          <Box sx={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px', boxShadow: 1, marginBottom: '20px' }}>
            <div className='flex justify-between items-center'>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#D71920', marginBottom: 2 }}>
                Summary
              </Typography>
              {/* <div className="text-blue-800 hover:cursor-pointer hover:text-blue-900">
                <Tooltip title="Download" arrow>
                  <FontAwesomeIcon
                    icon={faDownload}
                    fontSize="30px"
                    onClick={handleSummaryDownload}
                  />
                </Tooltip>
              </div> */}
            </div>
            <div className='flex justify-between items-center'>
              <div>
                <Typography variant="body1" sx={{ marginBottom: 1 }}>
                  <strong>Company Title:</strong> {summary.companyTitle}
                </Typography>
                <Typography variant="body1" sx={{ marginBottom: 1 }}>
                  <strong>Opening Balance:</strong> Rs.{(summary.openingBalance !== undefined ? (startFromZero ? 0 : summary.openingBalance) : 0).toFixed(2)}
                </Typography>
                <Typography variant="body1" sx={{ marginBottom: 1 }}>
                  <strong>Closing Balance:</strong> Rs.{Number(displayClosingBalance).toFixed(2)}
                </Typography>
                <Typography variant="body1" sx={{ marginBottom: 1 }}>
                  <div className='flex items-center gap-2'>
                    <strong>Members Summary: </strong>
                    <button
                      onClick={() => setIsViewModalOpen(true)}
                      className="bg-green-700 text-white hover:bg-green-800 py-1 px-2 rounded-md flex items-center justify-center gap-2 w-full md:w-auto"
                    >
                      View Details
                    </button>
                  </div>

                </Typography>
              </div>
              <div>
                {/* <Typography variant="body1" sx={{ marginBottom: 1 }}>
                  <strong>Total Received:</strong> Rs.{summary.totalReceived.toFixed(2)}
                </Typography> */}
                <Typography variant="body1" sx={{ marginBottom: 1 }}>
                  <strong>Total Expected Income:</strong> Rs.{Number(bankFilteredTotal !== null ? bankFilteredTotal : summary.totalIncome).toFixed(2)}
                </Typography>
                <Typography variant="body1" sx={{ marginBottom: 1 }}>
                  <strong>Total Receivables:</strong> Rs.{summary.totalReceivable.toFixed(2)}
                </Typography>
                <Typography variant="body1" sx={{ marginBottom: 1 }}>
                  <strong>Total Expenses:</strong> Rs.{summary.totalExpenses.toFixed(2)}
                </Typography>
                <Typography variant="body1" sx={{ marginBottom: 1 }}>
                  <strong>Total Discount Given:</strong> Rs.{summary?.totalDiscount?.toFixed(2) || 0}
                </Typography>
              </div>
            </div>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                marginTop: 2,
                color: displayNetRevenue >= 0 ? '#F7931E' : '#f44336',
                display: 'flex',
                justifyContent: 'flex-end', // Aligns the content to the right
                width: '100%' // Ensures it takes the full width
              }}
            >
              <strong>Net Revenue:</strong> Rs.{Number(displayNetRevenue).toFixed(2)}
            </Typography>
            {/* Filters for Transactions to filter them on basis of All, Cash and Bank Transfers */}
            {!loading && filtered_transaction && filtered_transaction.length !== 0 && (
              <>
                <div className='m-5 flex flex-wrap justify-center items-center'>
                  {tabData.map((tab, index) => (
                    <button
                      key={tab.key}
                      className={`
                            border border-gx-border text-gx-ink-soft font-bold p-2 px-5 transition-colors duration-300 
                            ${tabType === tab.key ? 'bg-gx-border' : ''} 
                            ${index === 0 ? 'sm:rounded-s-full' : ''} 
                            ${index === tabData.length - 1 ? 'sm:rounded-e-full' : ''}
                            w-full sm:w-auto mb-2 sm:mb-0
                        `}
                      style={{
                        backgroundColor: tabType === tab.key ? '#D71920' : 'transparent',
                        color: tabType === tab.key ? '#fff' : '#000',
                      }}
                      onClick={() => setTabType(tab.key)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
              </>
            )}

            <Box sx={{ marginBottom: '20px', justifyContent: 'space-between', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              <Typography variant="body1" sx={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px', boxShadow: 1, }}>
                <strong>Total Received:</strong> Rs.{Number(displayTotalReceived || 0).toFixed(2)}
              </Typography>
            </Box>
          </Box>

          {/* Transactions Table */}
          <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto overflow-x-auto">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>S/R</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Description</TableCell>
                  {reportType === 'bankReports' && (
                    <>
                      <TableCell sx={{ fontWeight: 'bold' }}>Member ID</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Voucher ID</TableCell>
                    </>
                  )}
                  <TableCell sx={{ fontWeight: 'bold' }}>Account</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Payment Reference</TableCell>
                  {reportType === 'bankReports' && (
                    <>
                      <TableCell sx={{ fontWeight: 'bold' }}>Bank Name</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Bank GL</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>A/C Number</TableCell>
                    </>
                  )}
                  <TableCell sx={{ fontWeight: 'bold' }}>Debit</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Credit</TableCell>
                  {reportType !== 'bankReports' && (
                    <>
                      <TableCell sx={{ fontWeight: 'bold' }}>Member</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Member Balance</TableCell>
                    </>
                  )}
                  <TableCell sx={{ fontWeight: 'bold' }}>Company Balance</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedTransactions.map((transaction, index) => {
                  const offset = startFromZero && summary?.openingBalance ? summary.openingBalance : 0;
                  return (
                  <TableRow hover key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      {dayjs(transaction?.date).format("MMM DD, YYYY")}
                    </TableCell>
                    <TableCell>{transaction?.description || "---"}</TableCell>
                    {reportType === 'bankReports' && (
                      <>
                        <TableCell>{transaction?.member_id_formatted || "---"}</TableCell>
                        <TableCell>{transaction?.voucher_id_display || "---"}</TableCell>
                      </>
                    )}
                    <TableCell>{transaction?.account || "---"}</TableCell>
                    <TableCell>{transaction?.payment_reference || '—'}</TableCell>
                    {reportType === 'bankReports' && (
                      <>
                        <TableCell>{transaction?.bank_name || "---"}</TableCell>
                        <TableCell>{transaction?.bank_gl || "---"}</TableCell>
                        <TableCell>{transaction?.account_number || "---"}</TableCell>
                      </>
                    )}
                    <TableCell>{transaction?.debit || 0}</TableCell>
                    <TableCell>{transaction?.credit || 0}</TableCell>
                    {reportType !== 'bankReports' && (
                      <>
                        <TableCell>{transaction?.member_name || '—'}</TableCell>
                        <TableCell>
                          {transaction?.member_balance === '' || transaction?.member_balance == null
                            ? '—'
                            : Number(transaction.member_balance).toFixed(2)}
                        </TableCell>
                      </>
                    )}
                    <TableCell>{tabType === 'all' ? (transaction?.balance - offset) : tabType === 'cash' ? (transaction?.cashBalance - offset) : tabType === 'bank transfer' ? (transaction?.bankBalance - offset) : '0.00'}</TableCell>
                  </TableRow>
                  );
                })}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 50, { label: "All", value: -1 }]}
                    colSpan={12}
                    count={filtered_transaction.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </Box>
        </>
      ) : (
        <div className="bg-gx-border w-ful p-3 mt-10 rounded-lg m-10">
          <h3 className="text-xl font-bold text-center text-gx-ink-soft">
            No Records Found
          </h3>
        </div>
      )}

      <CustomModal isModal={isViewModalOpen} handleModal={toggleViewModal} size='2xl'>
        <Box sx={{ padding: '40px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#D71920', marginBottom: 2 }}>
            Member Summary
          </Typography>
          <div className='flex justify-between items-center'>
            <div>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Total Members:</strong> {memberSummary.totalMembers}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>New Members:</strong> {memberSummary.newMembers}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Returning Members:</strong> {memberSummary.returningMembers}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Members With Trainers:</strong> {memberSummary.membersWithTrainers}
              </Typography>
            </div>
            <div>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Male Members:</strong> {memberSummary.maleMembers}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Female Members:</strong> {memberSummary.femaleMembers}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Male Members With Trainer:</strong> {memberSummary.maleMembersWithTrainers}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Female Members With Trainer:</strong> {memberSummary.femaleMembersWithTrainers}
              </Typography>
            </div>
          </div>
        </Box>
      </CustomModal>
    </>
  );
}

export default CompanyLedgers